<template>
   <vs-prompt
        class="calendar-event-dialog"
        title="Add Time Off"
        accept-text= "Add Time Off"
        @accept="addTime"
        @cancel="removeData"
        :active.sync="activePromptAddEvent.isOpen">
          <div class="vx-row mb-4">
            <div class="vx-col sm:w-1/4 w-full flex align-center">
              <span class="text-sm">Day Off</span>
            </div>
            <div class="vx-col sm:w-3/4 w-full">
              <datepicker name="start-date" :disabledDates="disabledDates" v-model="startDate"></datepicker>
            </div>
          </div>
          <transition name="list">
          <div class="vx-row mb-4" v-if="active == false || active == 0">
            <div class="vx-col sm:w-1/4 w-full flex align-center">
              <span class="text-sm">Duration</span>
            </div>
            <div class="vx-col sm:w-3/4 w-full">
              <div class="flex align-center">
                <vue-timepicker class="w-1/2 mr-2 my-select-height" format="hh:mm A" v-model="startTime"></vue-timepicker> -
                <vue-timepicker class="w-1/2 ml-2 my-select-height" format="hh:mm A" v-model="endTime"></vue-timepicker>
              </div>
            </div>
          </div>
          </transition>
        <div class="vx-row w-full m-0 mb-4">
          <div class="vx-col sm:w-1/4 w-full"></div>
          <div class="vx-col sm:w-3/4 w-full flex align-center justify-between md:pl-2 pl-0 pr-0">
            <div class="flex align-left staff-allDay-inputs-holder">
              <!-- <div class="checkboxholder" :class="{'active' : active == 1}" id="timeOff-allday-checkbox" @click="changActive">
                <div class="checkboxwrapper">
                  <a href="javascript:void(0);" class="checkBox"></a>
                </div>
                <span class="check-box-text text-sm">All Day</span>
              </div> -->
              <vs-checkbox class="all-day-checkbox mx-0" id="timeOff-allday-checkbox" v-model="active">All day</vs-checkbox>
            </div>
           <div class="more-option text-sm" @click="changeMoreOption">
              <a class="flex align-center" href="javascript:void(0);" v-if="moreOption == 0">
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4 stroke-current text-primary pr-1" /> More options
              </a>
              <a class="flex align-center" href="javascript:void(0);" v-else>
                <feather-icon icon="MinusIcon" svgClasses="h-4 w-4 stroke-current text-primary pr-1" /> More options
              </a>
           </div>
          </div>
        </div>
        <transition name="list">
        <div v-if="moreOption == 1" class="w-full">
          <div class="vx-row my-3">
            <div class="vx-col sm:w-1/4 w-full flex align-center">
                <label class="text-sm">Recurring?</label>
              </div>
              <div class="vx-col sm:w-3/4 w-full">
                <!-- <div class="staff-timeoff-inputs-holder" v-if="!recurring" @click="recurring = !recurring">
                  <div class="slider_holder timeoff-recuring-holder sliderdone" id="timeoff-recuring-holder">
                    <input type="hidden" class="sliderVal" value="no">
                    <span class="slider_off sliders" style="left: 1px;"> OFF </span>
                    <span class="slider_on sliders" style="left: -57px;"> ON </span>
                    <span class="slider_switch" style="left: 0px;"></span>
                  </div>
                </div>

                <div class="staff-timeoff-inputs-holder" v-else @click="recurring = !recurring">
                  <div class="slider_holder timeoff-recuring-holder sliderdone" id="timeoff-recuring-holder">
                    <input type="hidden" class="sliderVal" value="yes">
                    <span class="slider_off sliders" style="left: 60px;"> OFF </span>
                    <span class="slider_on sliders" style="left: 2px;"> ON </span>
                    <span class="slider_switch" style="left: 38px;"></span>
                  </div>
                </div> -->

                <vs-switch v-model="recurring">
                  <span slot="on">On</span>
                  <span slot="off">Off</span>
                </vs-switch>

              </div>
          </div>
          <transition name="list">
          <div v-if="recurring == true">
            <div class="vx-row my-3">
                <div class="vx-col sm:w-1/4 w-full flex align-center">
                  <span class="text-sm">Repeat</span>
                </div>
                <div class="vx-col sm:w-3/4 w-full">
                  <v-select class='repeat-select' v-model="repeatSelected" :options="repeatOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'" :clearable="false"/>
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col sm:w-1/4 w-full flex align-center">
                  <span class="text-sm">End Date</span>
                </div>
                <div class="vx-col sm:w-3/4 w-full">
                  <datepicker name="end-date" :disabledDates="disabledEndDates" v-model="endDate"></datepicker>
                </div>
              </div>
          </div>
          </transition>
          <div class="vx-row mb-4 mt-1">
            <div class="vx-col sm:w-1/4 w-full flex align-center">
              <label class="text-sm">Description</label>
            </div>
            <div class="vx-col sm:w-3/4 w-full">
              <vs-input class="inputx description" placeholder="Vacation, Holiday, Other..." v-model="description" />
            </div>
          </div>
        </div>
        </transition>
        <div class="timeOff-summary-li">
          <div v-if="active == true || active == 1">
            <label class="timeoff-summary-content" v-if="recurring == false">
              All day on {{getFormatDate(startDate)}}
            </label>
            <label class="timeoff-summary-content" v-else>
              <span v-if="type == 'week'">Every {{type}}, on {{getWeekDays(startDate)}}</span><span v-else>Every {{type}}, on the {{getFormatDayInMonth(startDate)}} day</span>
              <span v-if="endDate != ''"> until {{getFormatDate(endDate)}}</span>
            </label>
          </div>
          <div v-else>
            <label class="timeoff-summary-content">
              From {{getFormatDate(startDate)}} {{startTime}} to {{getFormatDate(startDate)}} {{endTime}}
            </label>
          </div>
        </div>
    </vs-prompt>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import VueTimepicker from 'vue2-timepicker'
import vSelect from 'vue-select'
import moment from 'moment'

export default {
  name: 'add-time-off',
  components:{
    Datepicker,
    VueTimepicker,
    vSelect
  },
  props: {
    activePromptAddEvent:{
      type: Object
    },
    typeBlock:{
      type: String
    },
    staff: {
      type: Object
    },
    action_type: {
      type: String
    },
    currentPage: {
      type: Number,
      default: 1
    },
    itemsPerpage: {
      type: Number,
      default: 5
    }
  },
  data(){
    let startDate = new Date();
    let typeBlockTime = '';
    let staff_id = '';
    if(this.typeBlock){
      if(this.typeBlock == 'business'){
        typeBlockTime = 1
        staff_id = ''
      }else{
        typeBlockTime = 2
        if(this.staff){
          staff_id = this.staff.user_id
        }
      }
    }
    return{
      staff_id,
      typeBlockTime,
      startDate,
      type: 'week',
      endDate: '',
      disabledDates: {
        to: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
      },
      disabledEndDates: {
        to: new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate())
      },
      active: true,
      moreOption: 0,
      startTime: '08:00 AM',
      endTime: '05:00 PM',
      description: '',
      recurring : false,
      recurringPopup: false,
      weekly: {id: 1, label: '1 Week' , value: 1},
      monthly: {id: 1, label: '1 Month' , value: 1},
      repeatOptions: [
        {id: 1, label: 'Weekly'},
        {id: 2, label: 'Monthly'},
      ],
      repeatSelected: {id: 1, label: 'Weekly'},
      isOpenLoading: false,
    }
  },
  watch:{
    startDate:{
      immediate: true,
      deep: true,
      handler() {
        this.disabledEndDates.to = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate());
        this.getWeekDays(this.startDate);
        this.getFormatDayInMonth(this.startDate);
      }
    },
    repeatSelected: {
      immediate: true,
      deep: true,
      handler() {
        if(this.repeatSelected){
          if(this.repeatSelected.id == 1){
            this.type = 'week'
          }else{
            this.type = 'month'
          }
        }
      }
    },
    activePromptAddEvent: {
      immediate: true,
      deep: true,
      handler() {
        if(this.activePromptAddEvent) {
          if(this.activePromptAddEvent.isOpen == false) {
            this.removeData();
          }
        }
      }
    }
  },
  methods:{
    removeData(){
      this.startDate = new Date(),
      this.type = 'week',
      this.endDate = '',
      this.active = true,
      this.moreOption = 0,
      this.startTime = '08:00 AM',
      this.endTime = '05:00 PM',
      this.description = '',
      this.recurring  = false,
      this.recurringPopup = false,
      this.repeatSelected = {id: 1, label: 'Weekly'},
      this.weekly = {id: 1, label: '1 Week' , value: 1},
      this.monthly = {id: 1, label: '1 Month' , value: 1};
    },
    getFormatDayInMonth(date){
      return moment(date).format('Do');
    },
    getWeekDays(date){
      return moment(date).format('dddd');
    },
    getFormatDate(date){
      return moment(date).format('LL');
    },
    changActive(){
      if(this.active == 1){
        this.active = 0;
      }else{
        this.active = 1;
      }
    },
    changeMoreOption(){
      if(this.moreOption == 1){
        this.moreOption = 0;
      }else{
        this.moreOption = 1;
      }
    },
    getTime(time){
      let hasKey = 0;
      let stringTime = '';
      if(time.indexOf('P') != -1){
        hasKey = 1;
      }
      if(hasKey == 1){
        if(parseInt(time.slice(0,2)) < 12)
        {
          stringTime = String(parseInt(time.slice(0,2)) + 12) + time.slice(2,5);
        }else{
          stringTime = String(parseInt(time.slice(0,2))) + time.slice(2,5)
        }
      }else{
        if(parseInt(time.slice(0,2)) == 12){
          if(parseInt(time.slice(0,2)) - 12 == 0){
            stringTime = '0' + String(parseInt(time.slice(0,2)) - 12) + time.slice(2,5);
          }else{
            stringTime = String(parseInt(time.slice(0,2)) - 12) + time.slice(2,5);
          }
        }else{
          stringTime = time.slice(0,5);
        }
      }
      return stringTime
    },
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if(this.loadTime){
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: this.action_type + ' block time failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    addTime(){
      const obj = {
        staff_id: this.staff_id,
        all_day: this.active == true || this.active == 1 ? 1 : 0,
        type: this.typeBlockTime,
        recurring: this.recurring == false ? '0' : '1',
        description: this.description,
        page: this.currentPage,
        'per-page': this.itemsPerpage
      }
      const data = {};
      if(this.active == 1 || this.active == true) {
        obj.start_date = moment(this.startDate).format('YYYY-MM-DD 00:00:00');
        obj.end_date = moment(this.startDate).format('YYYY-MM-DD 00:00:00');
      }else{
        obj.start_date = moment(this.startDate).format('YYYY-MM-DD') + ' ' + this.getTime(this.startTime) + ':00';
        obj.end_date = moment(this.startDate).format('YYYY-MM-DD') + ' ' + this.getTime(this.endTime) + ':00';
      }
      if(this.recurring == true){
        if(this.repeatSelected.id == 1){
          data.recurring_type = 'weekly'
        }else{
          data.recurring_type = 'monthly'
        }
        if(this.active == 1 || this.active == true){
          if(this.endDate == ''){
            // this.endDate = this.startDate
            data.recurring_end_date = null;
            obj.end_date = moment(this.startDate).format('YYYY-MM-DD 00:00:00');
          }else{
            data.recurring_end_date = moment(this.endDate).format('YYYY-MM-DD 00:00:00')
            obj.end_date = moment(this.startDate).format('YYYY-MM-DD 00:00:00')
          }
        }else{
          if(this.endDate == ''){
            // this.endDate = this.startDate
            data.recurring_end_date = null;
            obj.end_date = moment(this.startDate).format('YYYY-MM-DD') + ' ' + this.getTime(this.endTime) + ':00';
          }else{
            data.recurring_end_date = moment(this.endDate).format('YYYY-MM-DD') + ' ' + this.getTime(this.endTime) + ':00';
            obj.end_date = moment(this.startDate).format('YYYY-MM-DD') + ' ' + this.getTime(this.endTime) + ':00';
          }
        }
        obj.data = data;
      }
      // console.log(obj)
      this.openLoadingInDiv();
      this.$store.dispatch("business/CREATE_BUSINESS_TIME_OFF", obj).then(() => {
          this.closeLoading();
          this.$vs.notify({
            title:'Notification',
            text:'Add Block Time Success',
            color:'success',
            position:'top-right'})
        }).catch(() => {
          this.closeLoading();
          this.$vs.notify({
            title:'Notification',
            text:'Add Block Time Failed',
            color:'danger',
            position:'top-right'})
        })
    }
  },
  created(){
  }
}
</script>
